var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMiles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8A92B2",
    d: "M5.538,0 L18.461,0 C21.6,0 24,2.4 24,5.538 L24,18.462 C24,21.6 21.6,24 18.461,24 L5.538,24 C2.4,24 -8.8817842e-16,21.6 -8.8817842e-16,18.462 L-8.8817842e-16,5.538 C-8.8817842e-16,2.4 2.4,0 5.538,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43485A",
    d: "M21.9995,12 C21.9995,17.523 17.5225,22 11.9995,22 C6.4765,22 1.9995,17.523 1.9995,12 C1.9995,6.477 6.4765,2 11.9995,2 C17.5225,2 21.9995,6.477 21.9995,12 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "6.419 6.5 9.494 6.5 11.999 10.565 14.504 6.5 17.578 6.5 17.578 17 14.684 17 14.684 10.971 11.999 15.08 11.939 15.08 9.269 11 9.269 17 6.419 17"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiles);
export default __webpack_public_path__ + "static/media/miles.72cbcbb4c93e212a4db1cfb94138244a.svg";
export { ForwardRef as ReactComponent };